import { Link, useNavigate, useLocation } from "react-router-dom";
import { useBranding } from "./branding";
import { setPortalToken, getPortalToken } from "./portalApi";
import { LogOut, Phone, Mail, MapPin } from "lucide-react";

export default function PortalLayout({ children }) {
  const { branding, logoUrl } = useBranding();
  const nav = useNavigate();
  const loc = useLocation();
  const authed = !!getPortalToken();

  const primary = branding?.primary_color || "#0F4C81";

  const logout = () => {
    setPortalToken(null);
    nav("/portal/login", { replace: true });
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#FAFAF7]" data-testid="portal-layout">
      <header
        className="border-b border-slate-200 bg-white"
        style={{ boxShadow: "0 1px 0 rgba(15,23,42,0.04)" }}
      >
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
          <Link to={authed ? "/portal" : "/portal/login"} className="flex items-center gap-3 min-w-0">
            {branding?.has_logo ? (
              <img src={logoUrl} alt="" className="h-9 w-auto max-w-[120px] object-contain" />
            ) : (
              <div
                className="w-9 h-9 rounded-md flex items-center justify-center text-white font-bold text-lg shrink-0"
                style={{ background: primary }}
              >
                {(branding?.company_name || "?").charAt(0).toUpperCase()}
              </div>
            )}
            <div className="min-w-0">
              <div className="font-display font-bold text-[15px] text-slate-900 leading-tight truncate">
                {branding?.company_name || "Customer Portal"}
              </div>
              <div className="text-[11px] text-slate-500 leading-tight truncate">
                {branding?.tagline}
              </div>
            </div>
          </Link>
          {authed && loc.pathname !== "/portal/login" && (
            <button
              onClick={logout}
              data-testid="portal-logout-btn"
              className="text-sm text-slate-600 hover:text-slate-900 flex items-center gap-2 px-3 py-2 rounded-md hover:bg-slate-100"
            >
              <LogOut size={16} /> <span className="hidden sm:inline">Sign out</span>
            </button>
          )}
        </div>
      </header>

      <main className="flex-1 max-w-5xl w-full mx-auto px-4 sm:px-6 py-6 sm:py-10">
        {children}
      </main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-6 text-xs text-slate-500 flex flex-col sm:flex-row gap-3 sm:gap-6 sm:items-center justify-between">
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            {branding?.support_phone && (
              <a href={`tel:${branding.support_phone}`} className="flex items-center gap-1.5 hover:text-slate-900">
                <Phone size={12} /> {branding.support_phone}
              </a>
            )}
            {branding?.support_email && (
              <a href={`mailto:${branding.support_email}`} className="flex items-center gap-1.5 hover:text-slate-900">
                <Mail size={12} /> {branding.support_email}
              </a>
            )}
            {branding?.support_address && (
              <span className="flex items-center gap-1.5">
                <MapPin size={12} /> {branding.support_address}
              </span>
            )}
          </div>
          <div className="text-[11px] text-slate-400">
            Secure customer portal · © {new Date().getFullYear()} {branding?.company_name}
          </div>
        </div>
      </footer>
    </div>
  );
}

export const portalBtn = (primary) => ({
  background: primary || "var(--portal-primary, #0F4C81)",
});
